<template>
  <div class="md pb-3">
    <div class="row px-3 pt-2 mt-3">
      <h1>About</h1>
      <div class="col col-8 col-lg-9">
        <p v-html="short_description"></p>
        <p>
          Links:
          <a href="https://github.com/spmvg" target="_blank">GitHub</a>,
          <a href="https://www.linkedin.com/in/spmvangemert/" target="_blank">LinkedIn</a>.
        </p>
      </div>
      <div class="col col-4 col-lg-3">
        <img src="/images/aws-certified-solutions-architect.png">
      </div>
    </div>

    <div class="row px-3 mt-3">
      <div class="col col-12">
        <h2>
          Work
        </h2>
      </div>
    </div>

    <div class="row px-3 mt-1">
      <div class="col col-12 blogpost-date"><span><i>Jul. 2025 – now</i></span></div>
      <div class="col col-12">
        <strong>vangemert.dev – Founder</strong><br>
        <i>vangemert.dev is my IT consultancy.</i>
      </div>
    </div>
    <div class="row px-3 mt-3">
      <div class="col col-12 blogpost-date"><span><i>Feb. 2023 – Jun. 2025</i></span></div>
      <div class="col col-12">
        <strong>Chapter Lead Python – ABN AMRO Clearing Bank N.V.</strong><br>
        <i>ABN AMRO Clearing Bank N.V. is a global clearing bank.</i>
        <ul>
          <li>Manager of ~10 Python developers. Guided several towards raises and promotions. Responsible for technical leadership, hiring and their self-development.</li>
          <li>Refactored parts of a global legacy application handling significant financial transaction volume into AWS (asynchronous, serverless, APIs).</li>
          <li>Performed software development lifecycle activities like design, implementation, testing and maintenance.</li>
          <li>Gave presentations about Python and application security, for example during ABN AMRO onboarding or the Learning Week.</li>
        </ul>
      </div>
    </div>
    <div class="row px-3 mt-3">
      <div class="col col-12 blogpost-date"><span><i>Feb. 2022 – Jan. 2023</i></span></div>
      <div class="col col-12">
        <strong>Python Developer – ABN AMRO Clearing Bank N.V.</strong><br>
        <i>ABN AMRO Clearing Bank N.V. is a global clearing bank.<br></i>
        <ul>
          <li>Implemented SWIFT ISO formats (messaging for financial institutions). My code now powers transactions with more zeroes than I dared to imagine.</li>
          <li>Maintained a data-heavy ETL application, e.g. by migrating databases.</li>
          <li>My contributions were rewarded with a promotion to Chapter Lead.</li>
        </ul>
      </div>
    </div>
    <div class="row px-3 mt-3">
      <div class="col col-12 blogpost-date"><span><i>Feb. 2021 – Jan. 2022</i></span></div>
      <div class="col col-12">
        <strong>Data Scientist – NWWI</strong><br>
        <i>NWWI is a validation institute for property valuation.<br></i>
        <ul>
          <li>Increased efficiency across the organisation by developing APIs and machine learning pipelines in Python.</li>
          <li>Performed analyses and built dashboards for management.</li>
          <li>Integrated CI/CD best practices.</li>
        </ul>
      </div>
    </div>
    <div class="row px-3 mt-3">
      <div class="col col-12 blogpost-date"><span><i>Apr. 2019 – Jan. 2021</i></span></div>
      <div class="col col-12">
        <strong>Customer Engineer – Energyworx B.V.</strong><br>
        <i>Energyworx is a cloud-based energy data platform.<br></i>
        <ul>
          <li>Solved critical issues before and after the go-live of a major electric utility in Python.</li>
          <li>Reduced incident response time by implementing monitoring on Google Cloud Platform.</li>
          <li>Reduced number of issues after releases by improving git workflows.</li>
          <li>Became a sparring partner for other developers, for example in code reviews.</li>
        </ul>
      </div>
    </div>
    <div class="row px-3 mt-3">
      <div class="col col-12 blogpost-date"><span><i>Dec. 2018 – Mar. 2019</i></span></div>
      <div class="col col-12">
        <strong>Intern (MSc) – Merck KGaA</strong><br>
        <i>Merck KGaA is a multinational science and technology company.<br></i>
        <ul><li>Internship: developed reinforcement learning method in Python.</li></ul>
      </div>
    </div>
    <div class="row px-3 mt-3">
      <div class="col col-12 blogpost-date"><span><i>Jun. 2017 – Feb. 2018</i></span></div>
      <div class="col col-12">
        <strong>Business Intelligence (part-time) – Delft Circuits B.V.</strong><br>
        <i>Delft Circuits produces quantum computing hardware.<br></i>
        <ul><li>Made a tool that mines scientific publications for market research in cryogenic circuit technology using Python.</li></ul>
      </div>
    </div>
    <div class="row px-3 mt-3">
      <div class="col col-12 blogpost-date"><span><i>Feb. 2015 – Jul. 2017</i></span></div>
      <div class="col col-12">
        <strong>Research assistant (part-time) – Disdrometrics B.V.</strong><br>
        <i>Disdrometrics produces acoustical rain sensors.<br></i>
        <ul>
          <li>Rainfall sensor data analysis in Python and MATLAB.</li>
          <li>Designing and maintaining calibration setup prototypes for acoustical rain sensors.</li>
        </ul>
      </div>
    </div>

    <div class="row px-3 mt-3">
      <div class="col col-12">
        <h2>
          Education
        </h2>
      </div>
    </div>

    <div class="row px-3 mt-0">
      <div class="col blogpost-date"><span><i>2017 – 2019</i></span></div>
      <div class="col col-12">
        <strong>MSc Engineering Physics – Delft University of Technology</strong><br>
        Thesis: Towards adiabatic spin transfer - analog simulation in gate defined quantum dots
      </div>
    </div>
    <div class="row px-3 mt-2">
      <div class="col blogpost-date"><span><i>2013 – 2017</i></span></div>
      <div class="col col-12">
        <strong>BSc Engineering Physics – Delft University of Technology</strong><br>
        Minor: mathematical finance<br>
        Extracurricular: Honours programme
      </div>
    </div>
    <div class="row px-3 mt-2">
      <div class="col blogpost-date"><span><i>2007 – 2013</i></span></div>
      <div class="col col-12">
        <strong>Stedelijk Gymnasium Johan van Oldenbarnevelt</strong><br>
        Extracurricular: Junior College Utrecht 2011 – 2013
      </div>
    </div>

    <div class="row px-3 mt-4">
      <div class="col col-12">
        <h2>
          Certifications
        </h2>
      </div>
    </div>

    <div class="row px-3 mt-1">
      <div class="col col-9">
        <strong>AWS Certified Solutions Architect – Professional</strong><br>
      </div>
      <div class="col blogpost-date mr-auto"><span><i>2024</i></span></div>
    </div>
    <div class="row px-3 mt-3">
      <div class="col col-9">
        <strong>Bureau Zuidema – Inzicht in Invloed</strong><br>
      </div>
      <div class="col blogpost-date mr-auto"><span><i>2024</i></span></div>
    </div>
    <div class="row px-3 mt-3">
      <div class="col col-9">
        <strong>AWS Certified Solutions Architect – Associate</strong><br>
      </div>
      <div class="col blogpost-date mr-auto"><span><i>2021</i></span></div>
    </div>
  </div>
</template>

<script>
import short_description from '@/portfolio/description.js'

export default {
  data() {
    return {
      short_description: short_description
    }
  },
  created () {
    document.title = "About"
  }
}
</script>

<style scoped>
.md {
  text-align: left;
  background-color: rgb(43, 43, 43);
  border-radius: 10px;
}

.blogpost-date {
  text-align: right;
  white-space: nowrap;
  font-family: "Roboto", serif;
}

img {
  width: 100%;
}
</style>